import Image from './Image';
import DataItemImageValues from './DataItemImageValues';
import DataItemPointer from './DataItemPointer';
import DataItemImageNumber from './DataItemImageNumber';
import DataItemArcProgressBar from './DataItemArcProgressBar';
import DataItemLineProgressBar from './DataItemLineProgressBar';
import DataItemText from './DataItemText';
import Sprite from './Sprite';
import Widget from './Widget';
import { LayoutBase } from './LayoutBase';
import Slot from './Slot';
import File from './File';
import { WatchfaceRenderer } from '..';
import { RendererRuntime } from '../runtime';
import generateID from '@/utils/generate-id';

export const LayoutItemMap = {
  Image: Image,
  DataItemImageValues: DataItemImageValues,
  DataItemPointer: DataItemPointer,
  Sprite: Sprite,
  DataItemText: DataItemText,
  DataItemImageNumber: DataItemImageNumber,
  DataItemArcProgressBar: DataItemArcProgressBar,
  DataItemLineProgressBar: DataItemLineProgressBar,
  Widget: Widget,
  Slot: Slot,
  TextWatchface: DataItemText,
  File: File
};

export default class {
  private renderer: WatchfaceRenderer;

  constructor(renderer: WatchfaceRenderer) {
    this.renderer = renderer;
  }

  draw(layouts: ILayout[], parentPosi?: LayoutBase['posi']) {
    layouts
      ?.filter((item) => ['Layout', 'Item'].includes(item.tagType))
      .filter((item) => {
        // 过滤需要渲染的shape id
        const { _id } = item;
        const { renderLayoutIds } = this.renderer.options.renderTheme;
        return renderLayoutIds
          ? renderLayoutIds.some((item) => !!_id && _id.includes(item))
          : true;
      })
      .forEach((layout: ILayout) => {
        // 判断是否需要绘制

        // 子元素的位置为相对位置，在绘制时需要处理为绝对位置
        const { x: x0 = 0, y: y0 = 0 } = parentPosi ?? {};
        const {
          x: x1 = 0,
          y: y1 = 0,
          ref = '',
          _id = generateID(),
          _hidden = false,
          _scale = 1,
          _alpha = 1
        } = layout;
        const _conditionHidden = (layout as any)._conditionHidden ?? false;
        // 元素位置
        const posi: LayoutBase['posi'] = {
          x: Math.floor(x0 + x1),
          y: Math.floor(y0 + y1),
          offsetX: Math.floor(x1),
          offsetY: Math.floor(y1)
        };

        const renderer = this.renderer;

        // 元素数据
        const dataItem = renderer.runtime.dataItems[ref];
        const type = dataItem?.tagType;
        const _Layout = LayoutItemMap[type as 'Image'];
        if (!type || !_Layout) {
          return;
        }

        const _layout = new _Layout(
          renderer,
          dataItem,
          posi,
          _id,
          _scale,
          _alpha,
          layout.parameter
        );
        if (!_layout) return;
        // 判断是否需要绘制：_conditionHidden 不受 forceShowHidden 影响
        const shouldDraw = !_conditionHidden &&
          (!_hidden || this.renderer.options?.forceShowHidden);

        if (shouldDraw) {
          _layout?.draw();
        } else {
          // 不绘制，但写入 runtime state（位置和尺寸）
          // 确保 Konva 交互层和属性面板能正确获取数据
          const size = _layout.getSize();
          const stateKey = RendererRuntime.generateStateKey(
            dataItem.name ?? '',
            _id
          );
          renderer.runtime.state[stateKey] = {
            ...renderer.runtime.state[stateKey],
            width: size.width,
            height: size.height,
            x: posi.x,
            y: posi.y,
            offsetX: posi.offsetX,
            offsetY: posi.offsetY,
            _id
          };
        }
      });
  }
}
